/* eslint-disable no-undef */
export const MTP_BASE_URL = process.env.REACT_APP_MTP_BASE_URL;
export const ELEMENTAR_BASE_URL = process.env.REACT_APP_ELEMENTAR_BASE_URL;
// Opcional: aponta só a tela Notas (LevData) para outra API, ex.: local.
export const LEV_NOTAS_BASE_URL =
  process.env.REACT_APP_LEV_NOTAS_API_URL || ELEMENTAR_BASE_URL;
export const MTP_BUCKET_NAME = process.env.REACT_APP_MAKE_THE_PRICE_BUCKET_NAME;
export const ELEMENTAR_BUCKET_NAME = process.env.REACT_APP_ELEMENTAR_BUCKET;
export const NOTA_AVULSA_BASE_URL = process.env.REACT_APP_NOTA_AVULSA_BASE_URL;
export const HUMAN_LOOP_BASE_URL = process.env.REACT_APP_HUMAN_LOOP_BASE_URL;
export const ELEMENTAR_ANALYSIS_BASE_URL =
  process.env.REACT_APP_ELEMENTAR_ANALYSIS;
export const DLM_BASE_URL = process.env.REACT_APP_DLM_BASE_URL;
export const FORWARD_BASE_URL = process.env.REACT_APP_SECRET_MAN_BASE_URL;
export const FORWARD_KEY = process.env.REACT_APP_SECRET_MAN_KEY;
export const TRANSACTIONAL_BASE_URL =
  process.env.REACT_APP_TRANSACTIONAL_BASE_URL;
export const TRANSACTIONAL_KEY = process.env.REACT_APP_TRANSACTIONAL_KEY;
export const SAFE_NFSE_BASE_URL = process.env.REACT_APP_SAFE_NFSE_BASE_URL;
export const AIRLINE_BASE_URL = process.env.REACT_APP_AIRLINE_BASE_URL;
export const GPT_BASE_URL = process.env.REACT_APP_GPT_BASE_URL;
export const GPT_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;
export const CCS_BUCKET_NAME = process.env.REACT_APP_CCS_BUCKET;
export const CRYPTOJS_UUID_SECRET = process.env.REACT_APP_CRYPTOJS_UUID_SECRET;
export const REFORMA_TRIBUTARIA_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.REACT_APP_MTP_BASE_URL
    ? `${process.env.REACT_APP_MTP_BASE_URL}/reformatributaria`
    : '/api');
